import { createStore } from 'vuex'

export default createStore({
  state: {
    // 用户信息
    isAuthenticated: false,
    user: null,
    // 当前激活的导航项
    activeNavItem: 'home'
  },
  getters: {
    // 获取用户信息
    getUser: (state) => state.user,
    // 获取当前激活的导航项
    getActiveNavItem: (state) => state.activeNavItem,
    // 获取认证状态
    getIsAuthenticated: state => state.isAuthenticated
  },
  mutations: {
    // 设置当前激活的导航项
    setActiveNavItem(state, navItem) {
      state.activeNavItem = navItem
    },
    // 更新用户信息
    updateUser(state, user) {
      state.user = { ...state.user, ...user }
    },
    // 设置认证状态
    SET_AUTH(state, { isAuthenticated, user }) {
      state.isAuthenticated = isAuthenticated;
      state.user = user;
    }
  },
  actions: {
    // 初始化认证状态
    initAuth({ commit }) {
      const token = localStorage.getItem('token')
      const userStr = localStorage.getItem('user')
      const user = userStr ? JSON.parse(userStr) : null
      commit('SET_AUTH', { 
        isAuthenticated: !!token, 
        user 
      })
      return !!token
    },
    
    // 设置认证状态
    setAuth({ commit }, auth) {
      commit('SET_AUTH', auth)
    },
    
    // 登出
    logout({ commit }) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      commit('SET_AUTH', { isAuthenticated: false, user: null })
    },
    // 切换导航项
    changeNavItem({ commit }, navItem) {
      commit('setActiveNavItem', navItem)
    }
  },
  modules: {
  }
})